import flatpickr from "flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import monthSelectPlugin from '../../../../node_modules/flatpickr/dist/plugins/monthSelect'

const getDisabledDatesByDays = (days) => {
  if (!days)
    return []

  const today = new Date()
  const untilDate = today.setDate(today.getDate() + parseInt(days))

  return [{
    from: 'today',
    to: untilDate
  }]
}

const date = ($pickrs) => {
  $pickrs.forEach(($pickr) => {
    // const disableDates = getDisabledDatesByDays($pickr.getAttribute('minDays'))

    flatpickr($pickr, {
      allowInput: false,
      altFormat: 'd/m/Y',
      altInput: true,
      animate: false,
      dateFormat: 'Y-m-d',
      // disable: disableDates,
      // minDate: $pickr.getAttribute('minDate') || null,
      locale: {
        ...(app.locale === 'es') ? Spanish : null,
        firstDayOfWeek: 0
      },
    })
  })
}
const time = ($pickrs) => {
  $pickrs.forEach(($pickr) => {
    flatpickr($pickr, {
      allowInput: false,
      altFormat: 'h:i',
      altInput: true,
      animate: false,
      dateFormat: "H:i",
      enableTime: true,
      noCalendar: true,
      // minDate: $pickr.getAttribute('minDate') || null,
      time_24hr: true,
      locale: {
        ...(app.locale === 'es') ? Spanish : null,
        firstDayOfWeek: 0
      },
      onOpen: (selectedDates, dateStr, instance) => {
        instance.element.value = '12:00'
        instance.element.dispatchEvent(new Event('change'))
      },
    })
  })
}
const dateTime = ($pickrs) => {
  $pickrs.forEach(($pickr) => {
    // const disableDates = getDisabledDatesByDays($pickr.getAttribute('minDays'))

    flatpickr($pickr, {
      allowInput: false,
      altFormat: 'd/m/Y H:i',
      altInput: true,
      animate: false,
      enableTime: true,
      dateFormat: 'Y-m-d H:i',
      // disable: disableDates,
      // minDate: $pickr.getAttribute('minDate') || null,
      time_24hr: true,
      locale: {
        ...(app.locale === 'es') ? Spanish : null,
        firstDayOfWeek: 0
      }
    })
  })
}
const dateMonthYear = ($pickrs) => {
  $pickrs.forEach(($pickr) => {
    // const disableDates = getDisabledDatesByDays($pickr.getAttribute('minDays'))

    flatpickr($pickr, {
      allowInput: false,
      altFormat: 'd/m/Y H:i',
      altInput: true,
      animate: false,
      enableTime: true,
      dateFormat: 'Y-m-d H:i',
      // disable: disableDates,
      // minDate: $pickr.getAttribute('minDate') || null,
      time_24hr: true,
      locale: {
        ...(app.locale === 'es') ? Spanish : null,
        firstDayOfWeek: 0
      },
      plugins: [
        new monthSelectPlugin({
          shorthand: true, //defaults to false
          dateFormat: "Y-m", //defaults to "F Y"
          altFormat: "m-Y", //defaults to "F Y"
          theme: "light" // defaults to "light"
        })
      ]
    })
  })
}

class flatpickrInput {
  constructor() {
    this.dom = {
      flatpickr: document.querySelectorAll('input[type="flatpickr"]'),
      flatpickrDateTime: document.querySelectorAll('input[type="flatpickrDateTime"]'),
      flatpickrTime: document.querySelectorAll('input[type="flatpickrTime"]'),
      flatpickrMonthYear: document.querySelectorAll('input[type="flatpickrMonthYear"]'),
    }
  }
  init() {
    if (this.dom.flatpickr)
      date(this.dom.flatpickr)

    if (this.dom.flatpickrTime)
      time(this.dom.flatpickrTime)

    if (this.dom.flatpickrDateTime)
      dateTime(this.dom.flatpickrDateTime)

    if (this.dom.flatpickrMonthYear)
      dateMonthYear(this.dom.flatpickrMonthYear)
  }
}

export default flatpickrInput
